import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'usuarios/administradores-de-la-entidad/';

/**
 * GET Administradores
 * @returns {Promise<Array<object>>}
 */
export const getAdministradores = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Administrador
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAdministrador = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Administrador
  * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteAdministrador = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
